export default __webpack_public_path__ + "static/media/v-card.f21c1268.png";